module.exports = __webpack_public_path__ + "img/sole-benches.1cac2ada.svg";